import { render, staticRenderFns } from "./addIssueClarificationNotice.vue?vue&type=template&id=2c890ee3&scoped=true"
import script from "./addIssueClarificationNotice.vue?vue&type=script&lang=js"
export * from "./addIssueClarificationNotice.vue?vue&type=script&lang=js"
import style0 from "./addIssueClarificationNotice.vue?vue&type=style&index=0&id=2c890ee3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c890ee3",
  null
  
)

export default component.exports